const routes = {
  path: "/leads",
  name: "LeadsCSQ",
  component: () => import("./views/Leads.vue"),
  meta: { requiresAuth: true },
  props: (route) => Object.assign({}, route.query, route.params),
};

export default routes;
